import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Routes, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { EntityManagerProvider } from './data/entity-manager-provider';

export interface CanComponentDeactivate {
    canDeactivate: () => boolean | Observable<boolean> | Promise<boolean>;
}

@Injectable({ providedIn: 'root' })
export class CanDeactivateGuard  {
    canDeactivate(component: CanComponentDeactivate): Observable<boolean> | Promise<boolean> | boolean {
        return component.canDeactivate ? component.canDeactivate() : true;
    }
}

@Injectable({ providedIn: 'root' })
export class PrepareGuard  {
    constructor(public entityManagerProvider: EntityManagerProvider, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        try {
            return this.entityManagerProvider
                .prepare()
                .then(() => true)
                .catch((error) => {
                    console.error('Error connecting to data service: ' + EntityManagerProvider.serviceName, error);
                    return false;
                });
        } catch (error) {
            return false;
        }
    }
}
